export enum PurchaseAvailabilityType {
  Available = 1,
  TemporarilyOutOfStock = 2,
  NotYetPublished = 3,
  Reprinting = 4,
  ReprintUnderConsideration = 5,
  OutOfPrint = 6,
  Discontinued = 7,
  Cancelled = 8,
  Hazardous = 9,
  NotAvailable = 10,
  IncorrectProduct = 11,
  MarketRestricted = 12,
  DirectSupply = 13,
}
